import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";
import { useNavigate } from "react-router";
import Confetti from "react-confetti";
import { useWindowSize } from "react-use";

export default function OnboardingSuccessful() {
  const navigate = useNavigate();
  const { width, height } = useWindowSize();

  return (
    <div className="max-h-screen mt-32 bg-white flex items-center justify-center p-4">
      <Confetti width={width} height={height} opacity={0.5} />

      <div className="max-w-md w-full text-center space-y-6">
        <div className="flex justify-center">
          <CheckCircle2 className="h-20 w-20 text-green-500" />
        </div>
        <h1 className="text-3xl font-semibold text-gray-900">
          Onboarding Completed Successfully!
        </h1>
        <p className="text-gray-600">
          Congratulations on completing the onboarding process! You can now
          manage your shipments from the dashboard.
        </p>
        <Button
          onClick={() => navigate("/dashboard")}
          className="w-full py-6 text-lg"
        >
          Go to Dashboard
        </Button>
      </div>
    </div>
  );
}
